import { Content } from '../../types';

export const kanchanaburiContent: Content = {
  title: "קנצ'נבורי – טבע, היסטוריה ואותנטיות בתאילנד",
  imageUrl: '/images/thailand/kanchanaburi/kanchanaburi-wide.jpeg',
  introduction:
    "קנצ'נבורי הינו מחוז השוכן במערב תאילנד, במרחק של כשעתיים נסיעה מבנגקוק. במרכזו, נמצאת העיירה קנצ'נבורי, השוכנת על גדות הנהר קוואי. האזור מתאפיין באווירה אותנטית, טבע קסום, היסטוריה מרתקת ורוגע המאפשר בריחה מהמולת הערים הגדולות. ניתן לבקר במחוז לאורך כל השנה, אך החודשים המומלצים ביותר הם נובמבר עד אפריל, כאשר מזג האוויר נעים יותר ופחות לח.",
  sections: [
    {
      title: 'היסטוריה ומורשת מלחמת העולם השנייה',
      content:
        "לקנצ'נבורי היסטוריה משמעותית הקשורה למלחמת העולם השנייה. בתקופה זו, שלטו היפנים באזור והחלו בבניית קו הרכבת בין תאילנד לבורמה, שנועד להקל על העברת כוחות ואספקה. אחד מהמבנים המרכזיים שהוקמו במסגרת הפרויקט הינו גשר הפלדה על נהר הקוואי, אשר נבנה על ידי שבויי מלחמה של בעלות הברית ופועלים אסייתיים. תנאי העבודה הקשים הובילו למותם של כ-16,000 שבויים וכ-100,000 פועלים אסייתיים כתוצאה מרעב, מחלות, עינויים ועוד.",
      type: 'text',
    },
    {
      title: 'אתרים היסטוריים מומלצים לביקור',
      type: 'sub-headers',
      description:
        "אתרים היסטוריים מרכזיים בקנצ'נבורי הקשורים למורשת מלחמת העולם השנייה:",
      content: [
        {
          subtitle: 'בית הקברות לחללי המלחמה',
          text: 'מנוחה אחרונה לכ-7,000 חיילי בעלות הברית.',
        },
        {
          subtitle: 'מוזיאון המלחמה JEATH',
          text: 'מציג עדויות וסיפורים על חוויות השבויים במהלך עבודתם על קו הרכבת.',
        },
        {
          subtitle: 'מוזיאון הרכבות',
          text: 'מספק מידע נרחב על תהליך הבנייה והשלכותיו.',
        },
        {
          subtitle: 'אנדרטת הזיכרון היפנית',
          text: 'נבנתה על ידי היפנים לזכר ההרוגים בבניית הגשר.',
        },
      ],
    },
    {
      title: 'טבע ופארקים מרהיבים',
      type: 'sub-headers',
      description:
        "קנצ'נבורי מציעה למבקרים שלל אתרי טבע עוצרי נשימה, המתאימים לטיולים, רחצה והנאה מהנופים הירוקים של תאילנד.",
      content: [
        {
          subtitle: 'הפארק הלאומי ארוואן',
          text: 'אחד מהאתרים הפופולריים ביותר במחוז, המכונה גם "שמורת שבעת המפלים". הפארק מטופח ומאורגן היטב ומציע מסלולי הליכה נוחים לצד בריכות טבעיות קסומות. המפל השביעי נחשב לאטרקציה המרכזית, אך ניתן לשחות וליהנות במיוחד מהמפל השני והשלישי, בהם ישנן בריכות טבעיות עם מים צלולים ודגים קטנים המעניקים חוויית ספא טבעית.',
        },
        {
          subtitle: 'שמורת סאי יוק (Sai Yok National Park)',
          text: 'שמורה מדהימה עם מפלים יפים, מסלולי הליכה ומערות מסתוריות. המקום פחות מתוייר ולכן מספק חוויה שקטה ורגועה יותר.',
        },
        {
          subtitle: 'מערת פרא תאט (Tham Phra That Cave)',
          text: 'מערה מרשימה עם נטיפים וזקיפים יפהפיים, המתאימה לטיול קצר למחפשים חוויה קצת אחרת בטבע.',
        },
      ],
    },
    {
      title: "אטרקציות נוספות בקנצ'נבורי",
      type: 'sub-headers',
      description:
        "מעבר לאתרים ההיסטוריים ולפארקי הטבע, קנצ'נבורי מציעה מגוון אטרקציות מהנות:",
      content: [
        {
          subtitle: 'Safari Park Open Zoo',
          text: "גן חיות אינטראקטיבי המאפשר להאכיל חיות מקרוב, במיוחד ג'ירפות שמכניסות את צווארן לתוך אוטובוס הספארי – חוויה ייחודית ומהנה לכל הגילים.",
        },
        {
          subtitle: "עולם הפילים (Elephant's World)",
          text: 'מקום המציע חוויה אתית והומאנית עם פילים, ללא רכיבה או התעללות בבעלי החיים.',
        },
        {
          subtitle: 'מקדש מערת הנמר (Wat Tham Sua)',
          text: 'מקדש בודהיסטי מרהיב בראש גבעה, המציע תצפית פנורמית על האזור.',
        },
        {
          subtitle: "שוק הלילה של קנצ'נבורי",
          text: 'מקום מצוין ליהנות מאוכל תאילנדי מסורתי, לקנות מזכרות ולחוות את חיי הלילה המקומיים.',
        },
        {
          subtitle: 'ברים, פאבים ומסעדות מקומיות',
          text: 'העיירה מציעה מגוון אפשרויות בילוי עם אווירה אותנטית ונינוחה.',
        },
      ],
    },
    {
      title: "דרכי הגעה לקנצ'נבורי",
      type: 'sub-headers',
      description: "ניתן להגיע לקנצ'נבורי מבנגקוק במספר דרכים:",
      content: [
        {
          subtitle: 'רכבת',
          text: 'חוויה אותנטית וזולה, אם כי הנסיעה אורכת כ-3 שעות.',
        },
        {
          subtitle: 'אוטובוסים',
          text: 'יוצאים מתחנת Mo Chit ובדרך כלל נוחים ומהירים יותר מהרכבת.',
        },
        {
          subtitle: 'וואנים (מיניבוסים)',
          text: 'אופציה פופולרית ומהירה, זמינה בתחנות שונות בבנגקוק.',
        },
        {
          subtitle: 'מוניות פרטיות',
          text: 'האופציה היקרה ביותר, אך הנוחה ביותר למעדיפים נסיעה פרטית.',
        },
      ],
    },
    {
      title: 'בשורה התחתונה',
      content:
        "בשורה התחתונה, קנצ'נבורי הינה יעד מושלם לחובבי היסטוריה, טבע ושלווה. היא משלבת אתרים היסטוריים מרתקים עם נופים מרהיבים ואטרקציות לכל הגילים, מה שהופך אותה לאחת מהפנינים החבויות של תאילנד. בין אם הינכם חובבי היסטוריה, מטיילים בטבע או מחפשים מקום להירגע – קנצ'נבורי הינה היעד עבורכם!",
      type: 'text',
    },
  ],
};
